import type { BaseTextProps } from "./BaseText";
import { BodyText } from "./BodyText";

export const Subtitle = ({ size = "sm", colour = "secondary", children, ...textProps }: BaseTextProps) => {
    return (
        <BodyText {...textProps} size={size} colour={colour}>
            {children}
        </BodyText>
    );
};
